import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { constants } from '../../../config';
import { ScreenStore } from '../../../stores/ScreenStore';

const IPropTypes = {
  src: PropTypes.string.isRequired,
};

const CarouselImage = (props) => {
  const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.extraSmallMaxWidth;
  let sourceProps = {};
  if (mobileVersion) {
    const lowDensitySrc = `${props.src}-mobile-1x.jpg`;
    sourceProps = {
      src: lowDensitySrc,
      srcSet: `${lowDensitySrc} 1x, ${props.src}-mobile-2x.jpg 2x`,
    };
  } else {
    sourceProps = {
      src: `${props.src}-desktop-1x.jpg`,
    };
  }
  return (
    <img
      alt=""
      {...props}
      {...sourceProps}
    />
  );
};

CarouselImage.propTypes = IPropTypes;

const ObservedCarouselImage = observer(CarouselImage);

export { ObservedCarouselImage as CarouselImage };



// WEBPACK FOOTER //
// ./src/pages/product-detail/carousel-image/CarouselImage.jsx